import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Col, Modal, Row, Table } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import ReactDOMServer from "react-dom/server";
import { FaFilter } from 'react-icons/fa'; // Import an icon for the button
import Swal from 'sweetalert2';
import { PositionServices } from "../../services/PositionServices";
import { ownSubscribe, sendMessage, unSubscribe } from '../../stomp/StompSocket';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from "../components/AdminDropdown";
import BrokerDropdown from "../components/BrokerDropdown";
import ClientDropdown from "../components/ClientDropdown";
import MarketDropdown from "../components/MarketDropdown";
import MasterDropdown from "../components/MasterDropdown";
import NumberFormatter from "../components/NumberFormatter";
import ScriptDropdown from "../components/ScriptDropdown";
import { customStyles, the } from '../components/customStyles';

function Position() {
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const selectedAdminRef = useRef(selectedAdmin);
    const [selectedMaster, setSelectedMaster] = useState(null);
    const selectedMasterRef = useRef(selectedMaster);
    const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
    const selectedSubBrokerRef = useRef(selectedSubBrokerId);
    const [selectedClient, setSelectedClient] = useState(null);
    const selectedClientRef = useRef(selectedClient);
    const [selectedMarket, setSelectedMarket] = useState(null);
    const selectedMarketRef = useRef(selectedMarket);
    const [selectedScript, setSelectedScript] = useState(null);
    const selectedScriptRef = useRef(selectedScript);
    const [fromDate, setFromDate] = useState("");
    const [selectedBrokerId, setSelectedBrokerId] = useState(null);
    const selectedBrokerRef = useRef(selectedBrokerId);
    const [positionList, setPositionList] = useState([]);
    var [flattenedPositions, setFlattenedPositions] = useState([]);
    const [watchScripts, setWatchScripts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showPositionModal, setShowPositionModal] = useState(false);
    var user = BullCache.getFromCache("user");
    const allScripts = BullCache.getFromCache('allScripts');
  
    const [totalMTM, setTotalMTM] = useState(0);
    const [totalBuyQty, setTotalBuyQty] = useState(0);
    const [totalSellQty, setTotalSellQty] = useState(0);
    const [totalQty, setTotalQty] = useState(0);
    const [downMTM, setDownMTM] = useState(0);
    const [selfMTM, setSelfMTM] = useState(0);
    const [upMTM, setUpMTM] = useState(0);
    const [adminPartnership, setAdminPartnership] = useState(0);
    const [masterPartnership, setMasterPartnership] = useState(0);
    const [brokerPartnership, setBrokerPartnership] = useState(0);
    const [subBrokerPartnership, setSubBrokerPartnership] = useState(0);
    const [status, setStatus] = useState('ALL');
    
    const [positionMap, setPositionMap] = useState([]);
    var [first, setFirst] = useState();
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [checkedItems, setCheckedItems] = useState({});
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [selectedRowData2, setSelectedRowData2] = useState(null);
    const [orderType, setOrderType] = useState("MARKET");

    const handlePositionModalClose = () => {setShowPositionModal(false); setSelectedRowData({}); setSelectedRowData2({})};

    const handleSelectAll = (e) => {
        const newState = e.target.checked;
        setIsAllSelected(newState);
  
      const newCheckboxState = {};
        Object.entries(positionMap).forEach(([key1, mkw1]) => {
        Object.entries(mkw1.flattened).forEach(([key, mkw]) => {
            if(mkw.qty !== 0) {
               const compositeKey = `${key1}-${key}`;
                newCheckboxState[compositeKey] = newState;
            }
        });
        });
      setCheckedItems(prev => ({ ...prev, ...newCheckboxState }));
    };
  
    const handleCheckboxChange = (e, key) => {
      setCheckedItems((prevState) => ({
        ...prevState,
        [key]: e.target.checked,
      }));
    };

const handleExitClick = (e, mkw1) => {
    const lot2 = mkw1.type === 'Buy' ? mkw1.totalBuyLot - mkw1.totalSellLot : mkw1.totalSellLot - mkw1.totalBuyLot;
    const qty2 = mkw1.type === 'Buy' ? mkw1.qty : 0 - mkw1.qty;
    
    setSelectedRowData({ ...mkw1, lot: lot2, qty: qty2 });
    setSelectedRowData2({ ...mkw1, lot: lot2 , qty: qty2});
    setShowPositionModal(true);
    setOrderType("MARKET");
  };

  const handleRadioSelection = (selection) => {
    setOrderType(selection);
    setSelectedRowData({ ...selectedRowData, ltp: selectedRowData2.ltp })
  };

  const onLotchange= (e) => {
    if(selectedRowData.lot !== e.target.value) { 
      var lot1 = e.target.value > 0 ? e.target.value : '';
      let updatedQty = selectedRowData.qty; // Default to current qty
      Object.entries(allScripts).forEach( ([segment, scripts] ) => {
        if(segment === selectedRowData.segment){
          Object.entries(scripts).forEach( ([symbol, script] ) => {
            if(selectedRowData2.scriptName.split(" ")[0] === symbol){
              updatedQty = lot1 * script[0].quantity;
            }
          })
        }
      });
      if((/^\d*$/.test(updatedQty))) {
        setSelectedRowData({ ...selectedRowData, qty: updatedQty, lot: lot1});
      } 
    }
  }

  const onQtychange= (e) => { 
    if(selectedRowData.qty !== e.target.value) { 
      var qty1 = e.target.value > 0 ? e.target.value : '';
      let updatedLot = selectedRowData.lot; 
      Object.entries(allScripts).forEach( ([segment, scripts] ) => {
        if(segment === selectedRowData.segment){
          Object.entries(scripts).forEach( ([symbol, script] ) => {
            if(selectedRowData2.scriptName.split(" ")[0] === symbol){
              updatedLot = qty1 / script[0].quantity ;
            }
          })
        }
      });

      if((/^\d*$/.test(qty1))) {
        setSelectedRowData({ ...selectedRowData, qty: qty1, lot: updatedLot});
      }
    }
}

const handleBuySell = () => {
  //setShowPositionModal(false); 
  if(selectedRowData.lot === '' || selectedRowData.qty === ''){
      Swal.fire({
              icon: "warning",
              text: 'Lot and Quantity is required!'
            });
  } else if(orderType === 'LIMIT' && selectedRowData.ltp === '') {
   Swal.fire({
              icon: "warning",
              text: 'Price is required!'
            });
  } else {          
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes ',
        cancelButtonText: 'No',
        cancelButtonColor: "#d33",
    }).then((result) => {
        if (result.isConfirmed) {

          var selectedPositionList = [];
          var type= '';
          var rate = selectedRowData2.ltp;
          if (orderType === 'LIMIT' ) {
            if(selectedRowData.type === 'Sell') {
              type = rate > selectedRowData.ltp ? 'Buy-RL' : 'Buy-SL';
            } else {
              type = rate < selectedRowData.ltp ? 'Sell-RL' : 'Sell-SL';
            }
          } else{
            type = selectedRowData.type === "Buy" ? "Sell-MP" : "Buy-MP"
          }

            var position = {
              scriptId : selectedRowData.scriptId,
              userId: selectedRowData.userId,
              tradeBy: user.adminId,
              orderType: type,
              quantity: selectedRowData.qty,
              lot: selectedRowData.lot,
              rate: selectedRowData.ltp,
              inLimit: false,
              device: "Browser",
              "userAgent": navigator.userAgent
            }
            selectedPositionList.push(position);

          
            exitPositionCall(selectedPositionList);
          } 
        
      });
      }
};

    const handleModalShow = () => setShowModal(true);
    const handleModalClose = () => setShowModal(false);

  useEffect(() => {
      if (status === 'ALL') {
        getPosition();
      } else {
         setOutStandingList(positionList);
      }

  const updatePositionFromTrade = (trade) => {
    if (!trade.userId || !trade.scriptId) return;

    const isFilterActive = selectedClientRef.current || selectedBrokerRef.current || selectedMasterRef.current || selectedAdminRef.current
      || selectedMarketRef.current || selectedScriptRef.current;

    const scriptNameParts = (trade.scriptNameRaw || '').split('#');
    const tradeSegment = scriptNameParts[0] || '';
    const tradeSymbol = scriptNameParts[1] || '';

    if (selectedMarketRef.current && tradeSegment !== selectedMarketRef.current) return;
    if (selectedScriptRef.current && tradeSymbol !== selectedScriptRef.current) return;

    const isBuy = trade.orderType && trade.orderType.toUpperCase().includes('BUY');
    const tradeQty = trade.quantity || 0;
    const tradeLot = trade.lot || 0;
    const tradeNetRate = parseFloat(trade.netRate || trade.rate || 0);
    const tradeValue = tradeNetRate * tradeQty;

    setPositionMap((prevMap) => {
      let userFound = false;
      let scriptFound = false;

      const updatedMap = prevMap.map((pp) => {
        if (pp.userId !== trade.userId) return pp;

        userFound = true;

        const updatedFlattened = pp.flattened.map((mkw) => {
          if (mkw.scriptId !== trade.scriptId) return mkw;

          scriptFound = true;

          let newTotalBuy = parseFloat(mkw.totalBuy) || 0;
          let newTotalSell = parseFloat(mkw.totalSell) || 0;
          let newTotalBuyQty = parseInt(mkw.totalBuyQty) || 0;
          let newTotalSellQty = parseInt(mkw.totalSellQty) || 0;
          let newTotalBuyLot = parseFloat(mkw.totalBuyLot) || 0;
          let newTotalSellLot = parseFloat(mkw.totalSellLot) || 0;

          if (isBuy) {
            newTotalBuy += tradeValue;
            newTotalBuyQty += tradeQty;
            newTotalBuyLot += tradeLot;
          } else {
            newTotalSell += tradeValue;
            newTotalSellQty += tradeQty;
            newTotalSellLot += tradeLot;
          }

          const newQty = newTotalBuyQty - newTotalSellQty;
          const newType = newTotalBuy >= newTotalSell ? 'Buy' : 'Sell';
          const netQty = Math.abs(newQty);
          const newAverage = netQty === 0 ? 0
            : (newType === 'Buy'
              ? (newTotalBuy - newTotalSell) / netQty
              : (newTotalSell - newTotalBuy) / netQty);
          const newLot = newTotalBuyLot - newTotalSellLot;

          const newProfitLoss = newQty !== 0
            ? (parseFloat(mkw.ltp) - newAverage) * newQty
            : (newTotalSell - newTotalBuy);

          return {
            ...mkw,
            totalBuy: newTotalBuy,
            totalSell: newTotalSell,
            totalBuyQty: newTotalBuyQty,
            totalSellQty: newTotalSellQty,
            totalBuyLot: newTotalBuyLot,
            totalSellLot: newTotalSellLot,
            qty: newQty,
            bea: newAverage,
            type: newType,
            lot: newLot,
            profitLoss: newProfitLoss,
          };
        });

        if (!scriptFound) {
          const scriptNameParts = (trade.scriptNameRaw || '').split('#');
          const segment = scriptNameParts[0] || '';
          const newQty = isBuy ? tradeQty : -tradeQty;
          const newType = isBuy ? 'Buy' : 'Sell';
          const newLot = isBuy ? tradeLot : -tradeLot;

          updatedFlattened.push({
            userId: trade.userId,
            scriptId: trade.scriptId,
            segment: segment,
            scriptName: trade.script || '',
            totalBuy: isBuy ? tradeValue : 0,
            totalBuyQty: isBuy ? tradeQty : 0,
            totalBuyLot: isBuy ? tradeLot : 0,
            totalSell: !isBuy ? tradeValue : 0,
            totalSellQty: !isBuy ? tradeQty : 0,
            totalSellLot: !isBuy ? tradeLot : 0,
            qty: newQty,
            bea: tradeNetRate,
            ltp: parseFloat(trade.rate) || 0,
            type: newType,
            lot: newLot,
            profitLoss: 0,
            client: trade.userName || '',
            icon: ReactDOMServer.renderToString(
              <span className="fa fa-close nagative-amout-color" style={{ cursor: "pointer" }} size="sm"></span>
            ),
          });
        }

        const newTotalMTM = updatedFlattened.reduce((sum, f) => sum + f.profitLoss, 0);

        return {
          ...pp,
          flattened: updatedFlattened,
          totalMTM: newTotalMTM,
        };
      });

      if (!userFound && !isFilterActive) {
        const scriptNameParts = (trade.scriptNameRaw || '').split('#');
        const segment = scriptNameParts[0] || '';
        const newQty = isBuy ? tradeQty : -tradeQty;
        const newType = isBuy ? 'Buy' : 'Sell';
        const newLot = isBuy ? tradeLot : -tradeLot;

        const newEntry = {
          userId: trade.userId,
          name: trade.userName || '',
          subBrokerPartnership: 0,
          totalMTM: 0,
          flattened: [{
            userId: trade.userId,
            scriptId: trade.scriptId,
            segment: segment,
            scriptName: trade.script || '',
            totalBuy: isBuy ? tradeValue : 0,
            totalBuyQty: isBuy ? tradeQty : 0,
            totalBuyLot: isBuy ? tradeLot : 0,
            totalSell: !isBuy ? tradeValue : 0,
            totalSellQty: !isBuy ? tradeQty : 0,
            totalSellLot: !isBuy ? tradeLot : 0,
            qty: newQty,
            bea: tradeNetRate,
            ltp: parseFloat(trade.rate) || 0,
            type: newType,
            lot: newLot,
            profitLoss: 0,
            client: trade.userName || '',
            icon: ReactDOMServer.renderToString(
              <span className="fa fa-close nagative-amout-color" style={{ cursor: "pointer" }} size="sm"></span>
            ),
          }],
        };

        return [...updatedMap, newEntry];
      }

      return updatedMap;
    });

    setFlattenedPositions((prevFlat) => {
      let scriptFound = false;
      const updatedFlat = prevFlat.map((mkw) => {
        if (mkw.scriptId !== trade.scriptId || mkw.userId !== trade.userId) return mkw;

        scriptFound = true;
        let newTotalBuy = parseFloat(mkw.totalBuy) || 0;
        let newTotalSell = parseFloat(mkw.totalSell) || 0;
        let newTotalBuyQty = parseInt(mkw.totalBuyQty) || 0;
        let newTotalSellQty = parseInt(mkw.totalSellQty) || 0;
        let newTotalBuyLot = parseFloat(mkw.totalBuyLot) || 0;
        let newTotalSellLot = parseFloat(mkw.totalSellLot) || 0;

        if (isBuy) {
          newTotalBuy += tradeValue;
          newTotalBuyQty += tradeQty;
          newTotalBuyLot += tradeLot;
        } else {
          newTotalSell += tradeValue;
          newTotalSellQty += tradeQty;
          newTotalSellLot += tradeLot;
        }

        const newQty = newTotalBuyQty - newTotalSellQty;
        const newType = newTotalBuy >= newTotalSell ? 'Buy' : 'Sell';
        const netQty = Math.abs(newQty);
        const newAverage = netQty === 0 ? 0
          : (newType === 'Buy'
            ? (newTotalBuy - newTotalSell) / netQty
            : (newTotalSell - newTotalBuy) / netQty);
        const newLot = newTotalBuyLot - newTotalSellLot;
        const newProfitLoss = newQty !== 0
          ? (parseFloat(mkw.ltp) - newAverage) * newQty
          : (newTotalSell - newTotalBuy);

        return {
          ...mkw,
          totalBuy: newTotalBuy,
          totalSell: newTotalSell,
          totalBuyQty: newTotalBuyQty,
          totalSellQty: newTotalSellQty,
          totalBuyLot: newTotalBuyLot,
          totalSellLot: newTotalSellLot,
          qty: newQty,
          bea: newAverage,
          type: newType,
          lot: newLot,
          profitLoss: newProfitLoss,
        };
      });

      if (!scriptFound) {
        const scriptNameParts = (trade.scriptNameRaw || '').split('#');
        const segment = scriptNameParts[0] || '';
        const newQty = isBuy ? tradeQty : -tradeQty;
        const newType = isBuy ? 'Buy' : 'Sell';
        const newLot = isBuy ? tradeLot : -tradeLot;

        updatedFlat.push({
          userId: trade.userId,
          scriptId: trade.scriptId,
          segment: segment,
          scriptName: trade.script || '',
          totalBuy: isBuy ? tradeValue : 0,
          totalBuyQty: isBuy ? tradeQty : 0,
          totalBuyLot: isBuy ? tradeLot : 0,
          totalSell: !isBuy ? tradeValue : 0,
          totalSellQty: !isBuy ? tradeQty : 0,
          totalSellLot: !isBuy ? tradeLot : 0,
          qty: newQty,
          bea: tradeNetRate,
          ltp: parseFloat(trade.rate) || 0,
          type: newType,
          lot: newLot,
          profitLoss: 0,
          client: trade.userName || '',
          icon: ReactDOMServer.renderToString(
            <span className="fa fa-close nagative-amout-color" style={{ cursor: "pointer" }} size="sm"></span>
          ),
        });
      }

      return updatedFlat;
    });
  };

      const subscribeSocket = () => {
            ownSubscribe('/topic/dash/' + user.adminId, function (msg) {
                var trade = JSON.parse(msg.body);
                if(trade){
                    if(trade.tradeType === 'EXECUTED'){
                       updatePositionFromTrade(trade);
                    }
                }
            }, 'dash-subscribe-id2')
            };

    const timeoutId = setTimeout(() => {
         componentWillUnmount2();
            subscribeSocket();
   
    }, 2000);
    
    return () => {
        clearTimeout(timeoutId); 
      //  clearInterval(intervalId); 
        componentWillUnmount2();
    };


}, [status]); 

 const componentWillUnmount2 = () => {
    unSubscribe('dash-subscribe-id2');
  }

  useEffect(() => {
  selectedAdminRef.current = selectedAdmin;
}, [selectedAdmin]);

useEffect(() => {
  selectedMasterRef.current = selectedMaster
}, [selectedMaster]);

useEffect(() => {
  selectedSubBrokerRef.current = selectedSubBrokerId;
}, [selectedSubBrokerId]);

useEffect(() => {
  selectedBrokerRef.current = selectedBrokerId;
}, [selectedBrokerId]);

useEffect(() => {
  if(showModal) {
    selectedMarketRef.current = null;
    selectedScriptRef.current = null;
    selectedAdminRef.current = null;
    selectedMasterRef.current = null;
    selectedSubBrokerRef.current = null;
    selectedBrokerRef.current = null;
  }
}, [showModal]);

  const setOutStandingList =  (positionList1) => {
     const outstandingPosition = positionList1
        .map(position => {
          const filtered = position.position.filter(p => p.lot !== 0);
          return filtered.length > 0 ? { ...position, position: filtered } : null;
        })
        .filter(Boolean); // Remove nulls

        setPositionList(outstandingPosition)
  }

    const flattenPositionData = (positions) => {
        setTotalMTM(0);
        setTotalBuyQty(0);
        setTotalSellQty(0);
        setTotalQty(0);
        setDownMTM(0);
        var mapList = [];

        positions.forEach((position) => {
            var client = position.user;
            var usertotalMTM = 0;
            var flattened = [];

            if (Array.isArray(position.position)) {
                setAdminPartnership(position.adminPartnership);
                setMasterPartnership(position.masterPartnership);
                setBrokerPartnership(position.brokerPartnership);

                position.position.forEach((script) => {
                    usertotalMTM += script.profitLoss;
                    var scriptName = script.scriptName.split("#");
                    flattened.push({
                        userId: client.userid,
                        scriptId: script.scriptId,
                        segment: scriptName[0],
                        scriptName:
                            scriptName[1] +
                            " " +
                            moment(scriptName[2], "DD/MM/YYYY").format("DDMMMYYYY").toUpperCase(),
                        totalBuyQty: script.totalBuyQty,
                        totalBuyLot: script.totalBuyLot,
                        totalBuy: script.totalBuy,
                        totalSellQty: script.totalSellQty,
                        totalSellLot: script.totalSellLot,
                        totalSell: script.totalSell,
                        qty: script.totalBuyQty - script.totalSellQty,
                        bea: script.average,
                        ltp: parseFloat(script.ltp),
                        type: script.type,
                        profitLoss: script.profitLoss,
                        client:
                            position.user.firstName +
                            " (" +
                            client.userName +
                            ") / "+ client.admin,
                        icon: ReactDOMServer.renderToString(
                            <span
                                className="fa fa-close nagative-amout-color"
                                style={{ cursor: "pointer" }}
                                size="sm"
                            ></span>
                        ),
                    });

                    if (user.adminType !== 'SUBBROKER' && position.subBrokerPartnership && position.subBrokerPartnership > 0) {
                        setDownMTM((prevDownMTM) => prevDownMTM + (script.profitLoss * (position.subBrokerPartnership / 100)));
                    }
                    setTotalMTM((prevTotalMTM) => prevTotalMTM + script.profitLoss);
                    setTotalBuyQty((prevTotalBuyQty) => prevTotalBuyQty + parseInt(script.totalBuyQty));
                    setTotalSellQty((prevTotalSellQty) => prevTotalSellQty + parseInt(script.totalSellQty));

                    if (watchScripts[script.scriptId] === undefined) {
                        watchScripts.push(script.scriptId);
                    }

                });
            }

            const updatedFlattened = [...flattened];

            var postionMap1 = {
                userId: client.userid,
                name: client.firstName + " (" + client.userName + ")",
                subBrokerPartnership: position.subBrokerPartnership,
                totalMTM: usertotalMTM,
                flattened: updatedFlattened
            };

            mapList.push(postionMap1);

        });

        setPositionMap([...mapList]);
        return mapList;
    };

    useEffect(() => {
        const flattenedData = flattenPositionData(positionList);
        let flattened = [];
        flattenedData.forEach(map => {
            map.flattened.forEach(onj => {
                flattened.push(onj);
            })
        });
        setFlattenedPositions(flattened);
        componentWillUnmount1();
        setTimeout(() => {
            subscribeWatch();
        }, 200);

    }, [positionList]);

    useEffect(() => {
        setTotalQty(totalBuyQty - totalSellQty);
      }, [totalMTM]);

    const componentWillUnmount1 = () => {
        unSubscribe('watch-subscribe-id1');
    }

    const subscribeWatch = () => {
        ownSubscribe('/topic/watch/' + user.adminId, function (msg) {

            if (msg.body) {

                if (first) {
                    setFirst(false);
                } else {

                    const updatedDataArray = JSON.parse(msg.body); // Parse the incoming message body
                    setPositionMap((prevPositionMap) => {
                        return prevPositionMap.map((pp) => {
                            const updatedFlattened = pp.flattened.map((mkw) => {
                                const updatedData = updatedDataArray.find(
                                    (data) => data.id === mkw.scriptId
                                );

                                if (updatedData && ((mkw.type === 'Buy' && (parseFloat(updatedData.i2) > 0 || updatedData.i6)) || (mkw.type === 'Sell' && (parseFloat(updatedData.i4) > 0 || updatedData.i6) ))) {
                                    return {
                                        ...mkw,
                                        ltp: mkw.type === 'Buy' ? (parseFloat(updatedData.i2) > 0 ? parseFloat(updatedData.i2) : parseFloat(updatedData.i6)) : (parseFloat(updatedData.i4) > 0 ? parseFloat(updatedData.i4) : parseFloat(updatedData.i6)),
                                        profitLoss:
                                            mkw.qty !== 0
                                            ? ( (mkw.type === 'Buy' ? (parseFloat(updatedData.i2) > 0 ? parseFloat(updatedData.i2) : parseFloat(updatedData.i6)) : (parseFloat(updatedData.i4) > 0 ? parseFloat(updatedData.i4) : parseFloat(updatedData.i6))) - mkw.bea) * mkw.qty
                                                : mkw.profitLoss,
                                    };
                                }

                                return mkw; // Return unchanged if no updated data
                            });

                            return {
                                ...pp,
                                flattened: updatedFlattened,
                            };
                        });
                    });

                    setFlattenedPositions((prevPositions) =>
                        prevPositions.map((mkw) => {
                            const updatedData = updatedDataArray.find(
                                (data) => data.id === mkw.scriptId
                            );
                            var newMkw = mkw;
                            if (updatedData) {
                                newMkw = mkw;
                                newMkw.ltp = mkw.type === 'Buy' ? parseFloat(updatedData.i2) : parseFloat(updatedData.i4);
                                newMkw.profitLoss = mkw.qty != 0 ? ( (mkw.type === 'Buy' ? parseFloat(updatedData.i2) : parseFloat(updatedData.i4)) - mkw.bea) * mkw.qty : mkw.profitLoss;
                            }
                            return newMkw;
                        }));

                }
            }
        }, 'watch-subscribe-id1');

        const deduplicatedScripts = Array.from(new Set(watchScripts));
        setWatchScripts(deduplicatedScripts);
        if (deduplicatedScripts.length > 0) {
            sendMessage('/app/topic/watch/' + user.adminId, JSON.stringify(prepareFirstTimeRequest(deduplicatedScripts)));

            function prepareFirstTimeRequest(scripts) {
                return {
                    'scripts': scripts, isMobile: true, data: {}, wantToStop: false, wantToRemoveScripts: false
                };
            }
        }
    }

    useEffect(() => {
        setTotalMTM(0);
        setDownMTM(0);

        {
            Object.entries(positionMap).map(([key1, mkw1]) => {
                mkw1.totalMTM = 0;
                return Object.entries(mkw1.flattened).map(([key, mkw]) => {

                    mkw1.totalMTM += mkw.profitLoss;
                    setTotalMTM((prevTotalMTM) => prevTotalMTM + mkw.profitLoss);
                    if (mkw1.subBrokerPartnership  && user.adminType !== 'SUBBROKER') {
                        setDownMTM((prevDownMTM) => prevDownMTM + (mkw.profitLoss * (mkw1.subBrokerPartnership / 100)));
                    }
                }
                )
            })
        }

    }, [flattenPositionData]);

    useEffect(() => {

        if (totalMTM === 0) {
            setSelfMTM(0);
        } else {

            if (adminPartnership === null && masterPartnership === null && brokerPartnership === null) {
                if(user.parentPercentage){
                  setUpMTM(0-totalMTM * (user.parentPercentage / 100));
                  setSelfMTM(0 - totalMTM - (0 - downMTM) - (0 - totalMTM * (user.parentPercentage / 100)));
                } else{
                  if(user.adminType === 'SUBBROKER'){
                    setSelfMTM(subBrokerPartnership ? 0-(totalMTM*subBrokerPartnership/ 100) : 0);
                    setUpMTM((totalMTM*subBrokerPartnership/ 100)-totalMTM);
                    setDownMTM(0);
                  } else if(user.adminType === 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER'){
                    setSelfMTM(0 - totalMTM - (0 - downMTM));
                    setUpMTM(0);
                  } else {
                    setSelfMTM(0 - totalMTM - (0 - downMTM));
                    setUpMTM(0);
                  }
                }

            } else {
                var self = totalMTM;

                if (brokerPartnership) {
                    self = self * brokerPartnership / 100;
                }
                
                if (masterPartnership) {
                    self = self * masterPartnership / 100;
                }

                setUpMTM(0-self * (user.parentPercentage / 100));
                setSelfMTM(0 - (self - (self * (user.parentPercentage / 100))));
            }
        }

    }, [totalMTM]);

    const handleExitPosition = () => {
    
           Swal.fire({
                    title: 'Are you sure?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes ',
                    cancelButtonText: 'No',
                    cancelButtonColor: "#d33",
                }).then((result) => {
                    if (result.isConfirmed) {
    
                      var selectedPositionList = [];
                      Object.entries(checkedItems).forEach(([key, isSelected]) => {
                        if (isSelected) {
                          const record = findRecordByKey(key);
                          if (record) {
                            positionList.forEach(e =>{
                              if(e.user.userid === record.userId) {
                                e.position.forEach(p=>{
                                  if(p.scriptId === record.scriptId){
                                    var position = {
                                      scriptId : p.scriptId,
                                      userId: record.userId,
                                      tradeBy: user.adminId,
                                      orderType: p.type === "Buy" ? "Sell-MP" : "Buy-MP",
                                      quantity: p.qty,
                                      lot: p.type === "Buy" ? p.totalBuyLot - p.totalSellLot :  p.totalSellLot - p.totalBuyLot,
                                      rate: record.ltp,
                                      inLimit: false,
                                      device: "Browser",
                                      "userAgent": navigator.userAgent
                                    }
                                    selectedPositionList.push(position);
                                  }
                                });
                              }
                            });
                          }
                        }
                      });
                      
                      exitPositionCall(selectedPositionList);
                       
                    }
                  });
      };

      const exitPositionCall = (list) => {
      
          if(list.length > 0){
            PositionServices.exitPosition(list)
                        .then(res => {
                            if (res.code === 1) {
                                Swal.fire({
                                  html: 'Orders Placed!',
                                  icon: 'success',
                                  color: "#fff",
                                  background: "#000",
                                  showCloseButton: true,
                                  focusConfirm: true,
                                  confirmButtonText: `OK`
                              }).then((result) => {
                                window.location.reload();
                              });
      
                            } else {
                              Swal.fire({
                                icon: "error",
                                text: res.messages
                              });
                            }
                        })
                        .catch(error => {
                           Swal.fire({
                                  icon: 'error',
                                  text: error?.response?.data?.data?.errors[0]?.errorMessage || "General system error!"
                              });
                        });
      
              } else {
              Swal.fire({
                    icon: 'error',
                    text: 'Please select record!'
                });
          }
        }
      

        const findRecordByKey = (k) => {
          for (const [key1, mkw1] of Object.entries(positionMap)) {
            for (const [key2, mkw] of Object.entries(mkw1.flattened)) {
              const compositeKey = `${key1}-${key2}`;
              if (compositeKey === k) {
                return mkw;
              }
            }
          }
          return null;
        };

     const handleRollover = () => {
    
        Swal.fire({
          title: 'Are you sure?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes ',
          cancelButtonText: 'No',
          cancelButtonColor: "#d33",
       }).then((result) => {
          if (result.isConfirmed) {
    
            const selectedScripts = {};
            var present = false;
            Object.entries(checkedItems).forEach(([key, isSelected]) => {
              if (isSelected) {
                present = true;
                const record = findRecordByKey(key);
                if (record) {
                  const { userId, scriptId } = record; 
                  if (!selectedScripts[userId]) {
                    selectedScripts[userId] = [];
                  }
                  selectedScripts[userId].push(scriptId);
                }
              }
            });
    
            if(present) {
              const requestPayload = {
                adminId: user.adminId,
                device: 'BROWSER',
                userAgent: navigator.userAgent,
                scripts: selectedScripts, 
              };
    
              PositionServices.rollOver(requestPayload)
                .then((res) => {
                  if (res.code === 1) {
                    Swal.fire({
                      html: 'Request sent successfully',
                      icon: 'success',
                      color: "#fff",
                      background: "#000",
                      showCloseButton: true,
                      focusConfirm: true,
                      confirmButtonText: `OK`
                    }).then((result) => {
                      window.location.reload();
                    });
                  } else{
                    Swal.fire({
                      icon: "error",
                      text: res.messages
                    });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: 'error',
                    text: error?.response?.data?.data?.errors[0]?.errorMessage || "General system error!"
                });
                });
            }  else{
              Swal.fire({
                    icon: 'error',
                    text: 'Please select record!'
                });
            }
          }
        });
      }

    const handleMarketChange = (market) => {
        setSelectedMarket(market);
        selectedMarketRef.current = market;
    };

    const handleScriptChange = (script) => {
        setSelectedScript(script);
        selectedScriptRef.current = script;
    };
    const handleScriptReset = () => {
        setSelectedScript(null);
        selectedScriptRef.current = null;
    };
    const handleFromDateChange = (newDate) => {
        setFromDate(newDate);
    };
    const handleSelectedClientChange = (selected) => {
        setSelectedClient(selected?.userId);
        selectedClientRef.current = selected?.userId;
    };

    const getPosition = () => {
        const dataToSubmit = {
            adminId: user.adminId,
            loginId: user.adminId
        };

        const clientRef = selectedClientRef.current;

        if (clientRef) {
            dataToSubmit.userId =  clientRef;
            dataToSubmit.adminId = user.adminId;
        } else if (selectedBrokerRef.current != null) {
            dataToSubmit.adminId = selectedBrokerRef.current;
        } else if (selectedMasterRef.current != null) {
            dataToSubmit.adminId = selectedMasterRef.current?.value;
        } else if (selectedAdminRef.current != null) {
            dataToSubmit.adminId = selectedAdminRef.current?.value;
        }

        dataToSubmit.segment = selectedMarketRef.current;
        dataToSubmit.keyword = selectedScriptRef.current;
        
        PositionServices.getPosition(dataToSubmit)
            .then((resp) => {
                if (resp.code === 1 && resp.data.positionList) {
                    const pp = resp.data.positionList;
                    if(status == 'OUTSTANDING'){
                      setOutStandingList([...pp]);
                    } else{
                      setPositionList([...pp]);  
                    }
                } else{
                  setPositionList([]);
                }
            })
            .catch((error) => { });

            handleModalClose();
    };

    return (
        <div className="pb-5 white-background">
            <Card className="white-background">
                <Card.Body className="white-background pt-1 ps-3 pb-0">
                    <Row >
                        <Col className="h6 text-start text-black">FILTER</Col>

                        <Col className="text-end">
                            {/* Button to open the modal */}
                            <Button variant="black" onClick={handleModalShow} className="p-0 text-black">
                                <FaFilter size={18} />
                            </Button>
                        </Col>
                    </Row>

                    {/* Modal Popup */}
                    <Modal show={showModal} onHide={handleModalClose} size="sm">
                        <Modal.Header closeButton>
                            <Modal.Title>FILTER</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col className="">
                                    {/* <Row> */}
                                    <Form.Check
                                        inline
                                        defaultChecked
                                        label="ALL"
                                        className="fss-05 fw-bold"
                                        name="group1"
                                        type="radio"
                                        id="inline-radio-1"
                                        checked={status === 'ALL'}
                                        onChange={() => setStatus('ALL')}
                                    /><br />
                                    {/* </Row> */}

                                    {/* <Row> */}
                                    <Form.Check
                                        inline
                                        label="CLIENT WISE"
                                        className="fss-05 fw-bold m-0"
                                        name="group2"
                                        defaultChecked
                                        type="radio"
                                        id="inline-radio-2"
                                    />

                                    {/* </Row> */}
                                </Col>
                                <Col></Col>

                                <Col className="">
                                    {/* <Row> */}
                                    <Form.Check
                                        inline
                                        label="OUTSTANDING"
                                        className="fss-05 fw-bold mb-0"
                                        name="group1"
                                        
                                        type="radio"
                                        id="inline-radio-1"
                                        checked={status === 'OUTSTANDING'}
                                        onChange={() => setStatus('OUTSTANDING')}
                                    />
                                    {/* </Row> */}

                                    {/* <Row> */}
                                    <Form.Check
                                        inline
                                        label="SCRIPT WISE"
                                        className="fss-05 fw-bold m-0 mb-0"
                                        name="group2"
                                        type="radio"
                                        id="inline-radio-2"
                                    />
                                    {/* </Row> */}

                                    {/* <Row> */}
                                    <Form.Check
                                        inline
                                        label="SELF SUMMARY"
                                        className="fss-05 fw-bold m-0"
                                        name="group2"
                                        type="radio"
                                        id="inline-radio-3"
                                    />
                                    {/* </Row> */}
                                </Col>

                                <Row>
                                    <b className="fss-05">SEGMENT</b>
                                    <MarketDropdown
                                        allScripts={allScripts}
                                        onMarketChange={handleMarketChange}
                                        onScriptReset={handleScriptReset}
                                        value={selectedMarket}
                                    />
                                </Row>

                                <Row>
                                    <b className="fss-05">SCRIPT NAME</b>
                                    <ScriptDropdown
                                        allScripts={allScripts}
                                        selectedMarket={selectedMarket}
                                        onScriptChange={handleScriptChange}
                                        value={selectedScript}
                                    />
                                </Row>

                                {(user.adminType === 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER') && (
                                    <Row>
                                        <b className="fss-05">ADMIN</b>
                                        <AdminDropdown
                                            adminId={user.adminId}
                                            setSelectedOption={setSelectedAdmin}
                                        />
                                    </Row>
                                )}

                                {(user.adminType === 'SUPER_ADMIN' || user.adminType === 'ADMIN' || user.adminType == 'SUPER_MASTER') && (
                                    <Row>
                                        <b className="fss-05">MASTER</b>
                                        <MasterDropdown
                                            adminId={user.adminId}
                                            selectedAdmin={selectedAdmin}
                                            setSelectedOption={setSelectedMaster}
                                            setSelectedMaster={setSelectedMaster}
                                            setSelectedBrokerId={setSelectedBrokerId}
                                        />
                                    </Row>
                                )}

                                {(user.adminType === 'SUPER_ADMIN' || user.adminType === 'ADMIN' || user.adminType === 'MASTER' || user.adminType == 'SUPER_MASTER') && (
                                    <Row>
                                        <b className="fss-05">BROKER</b>
                                        <BrokerDropdown
                                            selectedAdmin={selectedAdmin}
                                            selectedMaster={selectedMaster}
                                            setSelectedOption={setSelectedBrokerId}
                                            setSelectedBrokerId={setSelectedBrokerId}
                                            setSelectedSubBrokerId={setSelectedSubBrokerId}
                                        />
                                    </Row>
                                )}

                                <Row>
                                    <b className="fss-05">CLIENT</b>
                                    <ClientDropdown
                                        selectedAdmin={selectedAdmin}
                                        selectedMaster={selectedMaster}
                                        selectedBrokerId={selectedBrokerId}
                                        selectedSubBrokerId={selectedSubBrokerId}
                                        setSelectedOption={handleSelectedClientChange}
                                    />
                                </Row>

                               
                            </Row>
                            <Row className="mt-1 ">
                                <Col>
                                    <Button variant="success" size="sm" className="fss-06 me-4" onClick={getPosition}>
                                        GET POSITION
                                    </Button>
                                </Col>
                                <Col>
                                    <Button variant="secondary" size="sm" className="fss-06">
                                        CLEAR FILTER
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Body>
                       
                    </Modal>

                    <Row className="mt-1 ps-1">
                        <Col className="text-start ps-0">
                            <Button variant="success" size="sm" className="fss-11 ps-3 pe-3 pt-2 pb-2" onClick={getPosition}>
                                Get Position
                            </Button>
                        </Col>
                        <Col className="text-center">
                        {user.adminType !== 'SUBBROKER' ?
                            <Button variant="danger" size="sm" className="fss-11 ps-3 pe-3 pt-2 pb-2" onClick={handleRollover}>
                                Rollover
                            </Button> : ""}
                        </Col>
                        <Col className="text-end pe-0">
                        {user.adminType !== 'SUBBROKER' ?
                            <Button variant="success" size="sm" className="fss-11 ps-3 pe-3 pt-2 pb-2" onClick={handleExitPosition}>
                                Exit Position
                            </Button>
                            :""}
                        </Col>
                    </Row>

                    <Row className="mt-1">
                        <Col xs={4} className="p-1 ">
                            <Card className="w-auto summary-card-mobile">
                                <Card.Body className="pt-1 p-0">
                                    <Row className="m-0">
                                        <Col
                                            className="text-center "
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            TOTAL MTM
                                            <br />
                                            <div className="summary-card-mobile-amount">
                                            <NumberFormatter number={totalMTM}></NumberFormatter>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col xs={4} className="p-1">
                            <Card className="w-auto summary-card-mobile">
                                <Card.Body className="pt-1 p-0">
                                    <Row className="m-0">
                                        <Col
                                            className="text-center"
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            SELF MTM
                                            <br />
                                            <div className="summary-card-mobile-amount">
                                            <NumberFormatter number={selfMTM}></NumberFormatter>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col xs={4} className="p-1">
                            <Card className="w-auto summary-card-mobile">
                                <Card.Body className="pt-1 p-0">
                                    <Row className="">
                                        <Col
                                            className="text-center"
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            DOWNLINE MTM
                                            <br />
                                            <div className="summary-card-mobile-amount">
                                            <NumberFormatter number={0 - downMTM}></NumberFormatter>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="mt-0">
                        <Col xs={4} className="p-1 pt-0">
                            <Card className="w-auto summary-card-mobile">
                                <Card.Body className="pt-1 p-0">
                                    <Row className="m-0">
                                        <Col
                                            className="text-center"
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            UPLINE MTM
                                            <br />
                                            <div className="summary-card-mobile-amount">
                                            <NumberFormatter number={upMTM}></NumberFormatter>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col xs={4} className="p-1 pt-0">
                            <Card className="w-auto summary-card-mobile">
                                <Card.Body className="pt-1 p-0">
                                    <Row className="m-0">
                                        <Col
                                            className="text-center"
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            BUY QTY
                                            <br />
                                            <div className="summary-card-mobile-amount">
                                            <NumberFormatter number={totalBuyQty}></NumberFormatter>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col xs={4} className="p-1 pt-0">
                            <Card className="w-auto summary-card-mobile">
                                <Card.Body className="pt-1 p-0">
                                    <Row className="m-0">
                                        <Col
                                            className="text-center "
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            SELL QTY
                                            <br />
                                            <div className="summary-card-mobile-amount">
                                            <NumberFormatter number={0 - totalSellQty}></NumberFormatter>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={4} className="p-1 me-4 pt-0 ">
                            <Card className="w-auto summary-card-mobile">
                                <Card.Body className="pt-1 p-0">
                                    <Row className="m-0">
                                        <Col
                                            className="text-center "
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            TOTAL QTY
                                            <br />
                                            <div className="summary-card-mobile-amount">
                                            <NumberFormatter number={totalQty}></NumberFormatter>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card className="mt-1 mb-5 white-background">
      <Card.Body className="p-0 white-background">
      {user.adminType !== 'SUBBROKER' ?
        <Row>
          <Col className="ms-2">
            <input
              type="checkbox"
              className="ms-1 "
              checked={isAllSelected}
              onChange={handleSelectAll}
              id="check-all"
            />
            <b className="h6 fss-07 ms-1 text-black">CHECK ALL</b>
          </Col>
        </Row>
        :""}
        <div className="white-background me-2 ms-2">
          <Table id="table" className="table text-center bg-secondary-row fss-08 position-table white-background">
            <tbody>
              {positionMap.length === 0 ? (
                <tr>
                  <td colSpan="14" className="text-center">
                    No data available
                  </td>
                </tr>
              ) : (
                Object.entries(positionMap).map(([clientKey, mkw1]) => {
                  let row = [];
                  Object.entries(mkw1.flattened).map(([key, mkw]) => {
                    const rowClass = mkw.qty !== '' ? (mkw.qty < 0 ? 'sell-row' : 'buy-row') : '';

                    row.push(
                      <React.Fragment key={`${clientKey}-${key}`} className="me-1">
                        <tr className={`${rowClass} me-2`} >
                          <td colSpan={2} className="p-0 ps-1 pt-1" style={{borderTopLeftRadius:"7px"}}>
                            <div className="d-flex align-items-center text-start fss-1 mt-1 fw-bold">
                              {mkw.scriptName}
                            </div>
                          </td>
                          <td style={{borderTopRightRadius:"7px"}} className="text-right pt-1">
                          {user.adminType !== 'SUBBROKER' ? <>
                            {mkw.scriptId !== '' && mkw.qty != 0  ? (
                              <span
                                className="fa fa-close nagative-amout-color "
                                style={{ cursor: 'pointer' }}
                                size="sm"
                                onClick={(e)=> handleExitClick(e, mkw)}
                              ></span>
                            ) : (
                              ''
                            )} </> : ""}
                          </td>
                        </tr>

                        <tr className={`${rowClass}`} >
                          <td className="text-start p-1">
                            <div className="d-flex align-items-center fss-1 ">
                              <b className=" me-1 text-nowrap fss-05">NET QTY</b>
                              {mkw.scriptId !== '' ? (
                                <span
                                  className={mkw.qty >= 0 ? 'positive-amout-color d-flex' : 'nagative-amout-color d-flex'}
                                >
                                  {(mkw.totalBuyQty - mkw.totalSellQty) +
                                    '('} <NumberFormatter number={mkw.totalBuyLot - mkw.totalSellLot}></NumberFormatter>{')'}
                                </span>
                              ) : (
                                ''
                              )}
                            </div>
                          </td>

                          <td className="text-start p-1">
                            <div className="d-flex align-items-center fss-1 ">
                              <b className="me-1 fss-05">B.E.AVG</b>
                              {mkw.scriptId !== '' ? (
                                mkw.bea > 0 ? (
                                  <NumberFormatter number={mkw.bea} />
                                ) : (
                                  '0.00'
                                )
                              ) : (
                                ''
                              )}
                            </div>
                          </td>

                          <td className="text-start p-1">
                            <div className="d-flex align-items-center fss-1">
                              <b className=" me-1 fss-05">LIVE</b>
                              {mkw.scriptId !== '' ? <NumberFormatter number={mkw.ltp} /> : mkw.ltp}
                            </div>
                          </td>
                        </tr>

                        <tr className={`${rowClass}`}>
                          <td className="text-start p-1" colSpan={2} style={{borderBottomLeftRadius:"7px"}}>
                          {user.adminType !== 'SUBBROKER' ? <>
                          {mkw.qty !== 0 ?
                              <input
                                type="checkbox"
                                checked={checkedItems[`${clientKey}-${key}`] || false} 
                                onChange={(e) => handleCheckboxChange(e, `${clientKey}-${key}`)} 
                                id={`checkbox-${clientKey}-${key}`} 
                              />
                             : ''
                            }</> : ""}
                          <span className="fss-1 ms-2">{mkw.client}</span> </td>

                          <td className="text-start p-0" style={{borderBottomRightRadius:"7px"}}>
                            <div className="d-flex align-items-center fss-1">
                              <b className=" me-1 fss-05">MTM</b>
                              <span className={mkw.profitLoss < 0 ? 'nagative-amout-color' : 'positive-amout-color'}>
                            {mkw.profitLoss !== null ? <NumberFormatter number={mkw.profitLoss}></NumberFormatter> : 0}
                          </span>
                               </div>
                          </td>
                         
                        </tr>
                        <tr  key={`margin-bottom-${key}`} style={{ height: '8px' }}>
                          <td colSpan="3" style={{ padding: '0', backgroundColor:'white' }}></td>
                        </tr>
                      </React.Fragment>
                    );
                  });

                  // After all records for the current client are processed, add the summary row
                  row.push(
                    <tr key={`summary-${clientKey}`} className="summary-row fss-1">
                      <td colSpan={2} className="white-background text-black text-start ms-2">{mkw1.name}</td>
                      <td className="white-background text-black">
                        <span
                          className={mkw1.totalMTM < 0 ? 'nagative-amout-color' : 'positive-amout-color'}
                        >
                          <NumberFormatter number={mkw1.totalMTM} />
                        </span>
                      </td>
                      
                    </tr>
                  );

                  return row;
                })
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>

    <Modal show={showPositionModal} onHide={handlePositionModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>CLOSE POSITION</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedRowData && (
                <>
                  <lable className="fss-08">CLIENT:  {selectedRowData.client}</lable><br></br>
                  <lable className="fss-08">SCRIPT:  {selectedRowData.scriptName}</lable>
                  <Row className='mt-1'>
                    <Col>
                      {["radio"].map((type) => (
                        <div key={`inline-${type}`}>
                          <Form.Check
                            inline
                            label="MARKET"
                            className="fss-08 custom-radio"
                            name="group3"
                            type={type}
                            checked={orderType === "MARKET"}
                            onChange={() => handleRadioSelection("MARKET")}
                          />
                          <Form.Check
                            inline
                            label="LIMIT"
                            className="fss-08 custom-radio"
                            name="group3"
                            type={type}
                            checked={orderType === "LIMIT"}
                            onChange={() => handleRadioSelection("LIMIT")}
                          />
                        </div>
                      ))}
                    </Col>
                  </Row>
                  <Row className='mt-1'>
                    <Col>
                      <label className="fss-08">LOT</label>
                      <Form.Control
                        type="number"
                        value={selectedRowData.lot !== null ? String(selectedRowData.lot).includes('.') ? Number(selectedRowData.lot).toFixed(2)
                          :  selectedRowData.lot : '' }
                        theme={the}
                        styles={customStyles}
                        className='bg-light text-black'
                        onChange={(e) => onLotchange(e)}
                      />
                    </Col>
                    <Col>
                      <label className="fss-08">QTY</label>
                      {selectedRowData.segment === "MCX" ?
                      <Form.Control
                        type="number"
                        value={selectedRowData.qty}
                        theme={the}
                        styles={customStyles}
                        className='bg-light text-black'
                        readOnly
                      /> : 
                      <Form.Control
                        type="number"
                        value={selectedRowData.qty}
                        theme={the}
                        styles={customStyles}
                        className='bg-light text-black'
                        onChange={(e) => onQtychange(e)}
                      />
                      }
                    </Col>
                  </Row>
                  <Row className='mt-2'>
                    <Col>
                      <label className="fss-08">PRICE</label>
                      {orderType === "MARKET" ?
                        <Form.Control
                          type="number"
                          value={selectedRowData.ltp}
                          theme={the}
                          styles={customStyles}
                          readOnly
                          className='bg-light text-black'
                        /> 
                        :
                        <Form.Control
                          type="number"
                          value={selectedRowData.ltp}
                          theme={the}
                          styles={customStyles}
                          className='bg-light text-black'
                          onChange={(e) =>
                            setSelectedRowData({ ...selectedRowData, ltp: e.target.value })
                          }
                      /> 
                      }
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col className="text-end">
                    <Button className="ps-4 pe-4" variant={selectedRowData.type === "Sell" ? "success" : "danger"}  onClick={handleBuySell}>
                     {selectedRowData.type === "Sell" ? "Buy" : "Sell"}
                    </Button>
                    </Col>
                  </Row>

                  </>
              )}

            </Modal.Body>
          </Modal>
          
        </div>
    );
}
export default Position;
